import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {formatAmountWithSuffix} from '../../../../lib/helpers'
import {IconHeart} from '../../../ui/Icons'

///////////////////////////////////////////////////////////////////////////////

export const TransactionInfoTransactionDetails = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const {transactionInfo, computedConfig} = api

  if (!transactionInfo) {
    return null
  }

  const amount = transactionInfo.amount
  const currency = transactionInfo.currency
  const purpose = transactionInfo.stored_rnw_purpose_id

  return (
    <section className="transaction-details">
      <div className="header">
        <div className="title">
          <h2 className="text">
            {api.trans('blocks.transaction_info.transaction_details.title')}
          </h2>
          <span className="icon" role="presentation">
            <IconHeart />
          </span>
        </div>
      </div>

      <p className="main">
        <span className="amount-and-recurring-interval">
          <span className="currency">{currency}</span>
          <span className="amount">
            {formatAmountWithSuffix(amount, currency, computedConfig)}
          </span>
        </span>

        {purpose && (
          <span className="purpose">
            {api.trans(
              'blocks.transaction_info.transaction_details.purpose_prefix',
            )}{' '}
            "{api.trans(`purposes.${purpose}`)}"
          </span>
        )}
      </p>
    </section>
  )
})
